// like !default / !edit / %21viewLogs
import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationViewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-view',
	path: '/secure/admin/ViewNotificationSchemes([!%]?[\\w]*).jspa',
};
